import React, { useEffect, useState } from 'react'
import { Header, Footer, Customerinfo, Tickettable, Infobox } from "../Components"
import { Link, useParams, useNavigate, useSearchParams } from "react-router-dom"
import { toast } from 'react-toastify'
import { Api, Images } from '../Constants'
import { useForm } from "react-hook-form";
import { FaHome } from 'react-icons/fa'

const Confirm = () => {
    const [isPageLoading, setIsPageLoading] = React.useState(true);
    const [customer, setCustomer] = useState({})
    const [tableData, settableData] = useState([])
    const [orderID, setOrderID] = useState(null)
    const [footData, setfootData] = useState({ subTotal: null, discount: null, taxable: null, vat: null, total: null })
    const [paymentMethod, setpaymentMethod] = useState([])
    const params = useParams();
    let navigate = useNavigate();
    const [isLoadingButton, setIsLoadingButton] = React.useState(false);
    // const [selectedPayment, setselectedPayment] = React.useState(2);
    const [selectedPayment, setselectedPayment] = useState(paymentMethod[0]?.id || "");
    const [esewaData, setEsewaData] = React.useState({});
    const [searchParams, setSearchParams] = useSearchParams();
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm()

    useEffect(() => {
        if (paymentMethod.length > 0) {
          setselectedPayment(paymentMethod[0].id);
        }
    }, [paymentMethod]);
    useEffect(() => {
        window.scrollTo(0, 0)
        setOrderID(params.id)
        let paystatus = searchParams.getAll('payment_status');
        paystatus = paystatus[0]
        if(paystatus==='failed'){
            toast.error('Payment failed. Please try again.');
        }
        const getData = async () => {
            const res = await Api.getOrders(params.id)
            const payres = await Api.getPaymentMethod()
            const esewares = await Api.getEsewaPayment(params.id)
            if (res.status) {
                setCustomer(res.data.Customer)
                let customer_ticket = res.data.tickets[0].customer_ticket
                settableData(customer_ticket)
                let subTotal = 0
                let discount = 0
                let taxable = 0
                let vat = 0
                let total_amount = 0

                customer_ticket.forEach(element => {
                    subTotal = parseFloat(subTotal) + parseFloat(element.amount)
                    discount = parseFloat(discount) + parseFloat(element.discount)
                    taxable = parseFloat(taxable) + parseFloat(element.taxable_amount)
                    vat = parseFloat(vat) + parseFloat(element.vat_amount)
                    total_amount = parseFloat(total_amount) + parseFloat(element.total_amount)
                    setfootData({
                        subTotal: subTotal.toFixed(2),
                        discount: discount.toFixed(2), 
                        taxable: taxable.toFixed(2), 
                        vat: vat.toFixed(2), 
                        total: Math.round(total_amount)+'.00'
                    })
                });
            }else{
                if (!toast.isActive('1')) {
                    toast.error('Failed to load data.');
                }
                return navigate("/");
            }
            if(payres.status){
                let resdata = payres.data.data
                let newdata = resdata.map(elem => {
                    let imgUrl
                    switch(elem.name.toLowerCase()){
                        case 'fonepay':
                            imgUrl = Images.fonepay
                            break;
                        case 'esewa':
                            imgUrl = Images.esewa
                            break;
                        case 'khalti':
                            imgUrl = Images.khalti
                            break;
                        default:
                            imgUrl = Images.rupee
                    }
                    return {
                        ...elem,
                        imgUrl: imgUrl,
                    }
                })
                setpaymentMethod(newdata)
                setIsPageLoading(false)
            }else {
                if (!toast.isActive('1')) {
                    toast.error('Failed to payment data.');
                }
                return navigate("/");
            }
            if(esewares.status){
                // console.log('esewa get data---',esewares.data.credentials)
                setEsewaData(esewares.data.credentials)
            }else{
                if (!toast.isActive('1')) {
                    toast.error('Failed to load data from esewa.');
                }
                // return navigate("/");
            }
        }
        getData()

        return () => {};
    }, []);
    
    // const confirmBook = async(orderID) => {
    //     setIsLoading(true)
    //     const bookingres = await Api.bookingconfirm(orderID)
    //     if (bookingres.status) {
    //         return navigate("/payment/"+orderID)
    //     }else{
    //         if (!toast.isActive('1')) {
    //             toast.error('Failed to confirm form submit. Please update the ticket data');
    //         }
    //         setIsLoading(false)
    //     }
    // }

    const onSubmit = async (data) => {
        console.log('form data',data)
        // return
        setIsLoadingButton(true)
        const res = await Api.postPaymentMethod(data,orderID)
        if(res.status) {
            // console.log('form success',res.data.url)
            // window.location.href = res.data.url
            window.location.href = res.data.url
            // return navigate(res.data.url);
            // const bookingres = await Api.bookingconfirm(orderID)
            // if (bookingres.status) {
            //     window.location.href = res.data.url
            //     // return navigate("/payment/"+orderID)
            // }else{
            //     if (!toast.isActive('1')) {
            //         toast.error('Failed to confirm form submit. Please update the ticket data');
            //     }
            //     setIsLoadingButton(false)
            // }
        }else {
            // console.log('form error',res.data)
            toast.error(res.data.message);
            setIsLoadingButton(false)
        }
        
    }
return(

<div>
    {isPageLoading ? (
    <div className='my-spinner-w'>
        <div className="spinner-grow" style={{'width': '3rem','height': '3rem'}}>
        </div>
        <div className='ms-3 mt-3'>Loading...</div>
    </div>) 
    : (<>
    <Header indicator={3}/>
    <div className="sm-section-container">
        <div className="container">
            {/* <h1 className='main-title display-6 text-uppercase pt-4'>Book a Ticket</h1> */}
            <div className="desktop-book pb-3">
                <div className='row flex-md-row flex-column-reverse'>
                    <div className="col-md-8">
                        <div className='d-flex justify-content-md-between justify-content-center'>
                            <h5 className="main-title2 display-6 text-uppercase pt-3 text-center text-md-start">Ticket Booking</h5>
                            <div className='pt-3 d-none d-md-block'>
                                <Link to={'/'}>
                                    <button className='btn btn-primary' title='Go Back To Homepage'>
                                        <FaHome />
                                    </button>
                                </Link>
                            </div>
                        </div>
                        <div className='d-block d-md-none'>
                            <Infobox step={3}/>
                        </div>
                        <div className='py-3 d-block d-md-none'>
                            <Link to={'/'}>
                                <button className='btn btn-primary' title='Go Back To Homepage'>
                                    <FaHome />
                                </button>
                            </Link>
                        </div>
                        {/* <div id="formindicator">
                        <div className="form-header d-flex mb-4 mt-2">
                            <span className="stepIndicator finish">Choose Ticket</span>
                            <span className="stepIndicator finish">Customer Details</span>
                            <span className="stepIndicator active">Confirmation</span>
                        </div>
                        </div> */}
                        {/* <h4 className="pb-3">Confirmation</h4> */}
                        {/* <h5 className="pb-3">Confirmation</h5> */}
                        <Tickettable tableData={tableData} footData={footData} />
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className='row'>
                                <div className='col-md-12 d-flex flex-xl-row flex-column justify-content-xl-between align-items-xl-end mb-2'>
                                    <div className='mt-2 d-block d-md-none'>
                                        <Customerinfo customer={customer} footData={footData} />
                                    </div>
                                    <div className="form-group mt-2 d-flex flex-column align-items-md-start align-items-center">
                                        <label className="col-form-label">Choose Payment Mode :</label>
                                        <div className="mt-3 d-flex">
                                            {paymentMethod.map((elem,index) => (
                                                <div className="form-check d-flex align-items-center me-3" key={index}>
                                                    <input 
                                                        className="form-check-input me-2" 
                                                        type="radio" 
                                                        name="paymethod"
                                                        value={elem.id}
                                                        id={"pay"+index}
                                                        {...register("payment_id", { required: true })} 
                                                        checked={selectedPayment === elem.id}
                                                        onChange={()=> setselectedPayment(elem.id)}
                                                    />
                                                    <label className="form-check-label cursor-pointer" htmlFor={"pay"+index}>
                                                        <img src={elem.imgUrl} alt="siddhartha payment" className="img-fluid pay-img" />
                                                    </label>
                                                </div>
                                            ))}
                                            {errors.payment_id && <div className='text-danger mt-2'>Please choose payment mode</div>}
                                        </div>
                                    </div>
                                    <div>
                                    <div className="">
                                        <div className="form-group mt-4 justify-content-md-end justify-content-center d-flex">
                                        {isLoadingButton ? (
                                                <div className="spinner-border" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            ) : (
                                                <>
                                            <Link 
                                                to={"/update/"+orderID}
                                                type="button" 
                                                className="btn btn-primary me-4" 
                                                title="Edit Information">
                                                Edit
                                            </Link>
                                            {selectedPayment === 2 ? 
                                            <form action={`${esewaData.api_url}`} method="POST">
                                                <div className='d-none'>
                                                    <input type="text" readOnly id="amount" name="amount" value={esewaData.amount} required/>
                                                    <input type="text" readOnly id="tax_amount" name="tax_amount" value ={esewaData.tax_amount} required/>
                                                    <input type="text" readOnly id="total_amount" name="total_amount" value={esewaData.total_amount} required/>
                                                    <input type="text" readOnly id="transaction_uuid" name="transaction_uuid" value={esewaData.transaction_uuid} required/>
                                                    <input type="text" readOnly id="product_code" name="product_code" value={esewaData.product_code} required/>
                                                    <input type="text" readOnly id="product_service_charge" name="product_service_charge" value={esewaData.product_service_charge} required/>
                                                    <input type="text" readOnly id="product_delivery_charge" name="product_delivery_charge" value={esewaData.product_delivery_charge} required/>
                                                    <input type="text" readOnly id="success_url" name="success_url" value={esewaData.success_url} required/>
                                                    <input type="text" readOnly id="failure_url" name="failure_url" value={esewaData.failure_url} required/>
                                                    <input type="text" readOnly id="signed_field_names" name="signed_field_names" value={esewaData.signed_field_names} required/>
                                                    <input type="text" readOnly id="signature" name="signature" value={esewaData.signature} required/>
                                                </div>
                                                <input value="Pay Now" title="Pay Now" type="submit" 
                                                    // className="btn btn-success my-btn-success" 
                                                    className="btn btn-primary" 
                                                />
                                            </form>
                                            :
                                            <button
                                                type="submit" 
                                                // className="btn btn-success my-btn-success"
                                                className="btn btn-primary" 
                                                // onClick={()=>confirmBook(orderID)}
                                                title="Pay Now">
                                                Pay Now
                                            </button>
                                            }
                                            </>
                                        )}
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        {/* <div className='row'>
                            <div className="col-md-8">
                                <div className="form-group mt-4 justify-content-end d-flex">
                                {isLoadingButton ? (
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : (
                                        <>
                                    <Link 
                                        to={"/update/"+orderID}
                                        type="button" 
                                        className="btn btn-primary me-4" 
                                        title="Edit Information">
                                        Edit
                                    </Link>
                                    {selectedPayment === 2 ? 
                                    <form action="https://rc-epay.esewa.com.np/api/epay/main/v2/form" method="POST">
                                        <div className='d-none'>
                                            <input type="text" readOnly id="amount" name="amount" value={esewaData.amount} required/>
                                            <input type="text" readOnly id="tax_amount" name="tax_amount" value ={esewaData.tax_amount} required/>
                                            <input type="text" readOnly id="total_amount" name="total_amount" value={esewaData.total_amount} required/>
                                            <input type="text" readOnly id="transaction_uuid" name="transaction_uuid" value={esewaData.transaction_uuid} required/>
                                            <input type="text" readOnly id="product_code" name="product_code" value={esewaData.product_code} required/>
                                            <input type="text" readOnly id="product_service_charge" name="product_service_charge" value={esewaData.product_service_charge} required/>
                                            <input type="text" readOnly id="product_delivery_charge" name="product_delivery_charge" value={esewaData.product_delivery_charge} required/>
                                            <input type="text" readOnly id="success_url" name="success_url" value={esewaData.success_url} required/>
                                            <input type="text" readOnly id="failure_url" name="failure_url" value={esewaData.failure_url} required/>
                                            <input type="text" readOnly id="signed_field_names" name="signed_field_names" value={esewaData.signed_field_names} required/>
                                            <input type="text" readOnly id="signature" name="signature" value={esewaData.signature} required/>
                                        </div>
                                        <input value="Pay Now" title="Pay Now" type="submit" 
                                            // className="btn btn-success my-btn-success" 
                                            className="btn btn-primary" 
                                        />
                                    </form>
                                    :
                                    <button
                                        type="submit" 
                                        // className="btn btn-success my-btn-success"
                                        className="btn btn-primary" 
                                        // onClick={()=>confirmBook(orderID)}
                                        title="Pay Now">
                                        Pay Now
                                    </button>
                                    }
                                    </>
                                )}
                                </div>
                            </div>
                        </div> */}
                        </form>
                        <div className='text-md-start text-center'>
                            <small>You will receive your ticket confirmation SMS on the provided mobile number.</small>
                        </div>
                    </div>
                    <div className="col-md-4 d-md-block d-none">
                        <div className='ms-md-5 ms-0'>
                            <Infobox step={3}/>
                        </div>
                        <div className='mt-5 ms-5 '>
                            <Customerinfo customer={customer} footData={footData} />
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
    <Footer />
    </>)}
</div>
)
}

export default Confirm
